import { Auth } from 'aws-amplify';

const currentUserEmail = async () => {
  try {
    var user = await Auth.currentAuthenticatedUser();
    //console.log(`awsUserInfo - aws user info: ${JSON.stringify(user)}`);
    console.log(`awsUserInfo - current user email: ${user.attributes.email}`);
    return user.attributes.email;
  } catch (e) {
    return e;
  }
};

const currentJwtToken = async () => {
  try {
    var user = await Auth.currentAuthenticatedUser();
    console.log(`awsUserInfo - current user jwtToken: ${user.signInUserSession.idToken.jwtToken}`);
    //return user.signInUserSession.idToken.jwtToken;
    // Auth.currentSession() checks if token is expired and refreshes with Cognito if needed automatically
    const session = await Auth.currentSession();
    // console.log(`awsUserInfo - current session jwtToken: ${session.idToken.jwtToken}`);
    // console.log(`token from awsUserInfo.js: ${JSON.stringify(session)}`);
    return session.idToken.jwtToken;
  } catch (e) {
    return e;
  }
};

const updateUserFirstName = async (action) => {
  let user = await Auth.currentAuthenticatedUser();
  console.log(`awsUserInfo - aws user info: ${JSON.stringify(user)}`);
  if (user.attributes.given_name !== action.firstName) {
    let result = await Auth.updateUserAttributes(user, {
      given_name: action.firstName
    });
    return result; // SUCCESS
  }
};

const updateUserLastName = async (action) => {
  let user = await Auth.currentAuthenticatedUser();
  console.log(`${JSON.stringify(user)}`);
  if (user.attributes.family_name !== action.lastName) {
    let result = await Auth.updateUserAttributes(user, {
      family_name: action.lastName
    });
    return result; // SUCCESS
  }
};

const updateUserEmail = async (action) => {
  let user = await Auth.currentAuthenticatedUser();
  console.log(`${JSON.stringify(user)}`);
  if (user.attributes.email !== action.email) {
    let result = await Auth.updateUserAttributes(user, {
      email: action.email
    });
    return result; // SUCCESS
  }
};

const updateUserPhone = async (action) => {
  let user = await Auth.currentAuthenticatedUser();
  console.log(`${JSON.stringify(user)}`);
  let newphone = action.phone.replace(/[- ()]/g, '');
  if (user.attributes.phone_number !== newphone) {
    console.log(
      `Start to call updateUserAttributes to change phone from ${user.attributes.phone_number} to ${newphone}`
    );
    let result = await Auth.updateUserAttributes(user, {
      phone_number: newphone
    });
    console.log(result);
    return result; // SUCCESS
  }
};

export default {
  currentUserEmail,
  currentJwtToken,
  updateUserFirstName,
  updateUserLastName,
  updateUserEmail,
  updateUserPhone
};
